import { 
  Container, 
  Typography, 
  Card, 
  CardContent,
  Alert,
  CircularProgress,
  Grid,
  Button,
  Box,
  CardActions
} from '@mui/material';
import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ROLES } from '../../utils/roles';
import { useNavigate } from 'react-router-dom';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';
import WorkIcon from '@mui/icons-material/Work';
import { authService } from '../../services/authService';

function Admin() {
  const navigate = useNavigate();
  const { userRole, loading } = useAuth();
  const [stats, setStats] = useState({
    nombre_pilotes: 0,
    nombre_etudiants: 0,
    nombre_entreprises: 0,
    nombre_offres: 0
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/dashboard`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${authService.getToken()}`
          }
        });

        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des statistiques');
        }

        const data = await response.json();
        setStats(data);
      } catch (err) {
        console.error("Erreur lors du chargement des statistiques:", err);
        setError("Impossible de charger les statistiques");
      }
    };

    if (userRole === ROLES.ADMIN) {
      fetchStats();
    }
  }, [userRole]);

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress color="primary" />
      </Container>
    );
  }

  if (userRole !== ROLES.ADMIN) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom
        sx={{
          opacity: 0,
          animation: 'fadeIn 0.8s ease-out forwards',
          '@keyframes fadeIn': {
            '0%': { opacity: 0 },
            '100%': { opacity: 1 }
          }
        }}
      >
        Tableau de bord administrateur
      </Typography>

      {error && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 2,
            opacity: 0,
            animation: 'fadeIn 0.8s ease-out 0.3s forwards',
            '@keyframes fadeIn': {
              '0%': { opacity: 0 },
              '100%': { opacity: 1 }
            }
          }}
        >
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        {[
          { icon: PeopleIcon, title: "Pilotes", count: stats.nombre_pilotes, path: "/pilotes" },
          { icon: SchoolIcon, title: "Étudiants", count: stats.nombre_etudiants, path: "/etudiants" },
          { icon: BusinessIcon, title: "Entreprises", count: stats.nombre_entreprises, path: "/entreprises" },
          { icon: WorkIcon, title: "Offres", count: stats.nombre_offres, path: "/offres" }
        ].map((item, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={3} 
            key={index}
            sx={{ 
              opacity: 0,
              animation: `fadeIn 0.8s ease-out ${0.3 + index * 0.2}s forwards`,
              '@keyframes fadeIn': {
                '0%': { opacity: 0, transform: 'translateY(30px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' }
              }
            }}
          >
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <item.icon sx={{ color: 'primary.main', mr: 1, fontSize: 30 }} />
                  <Typography variant="h6">{item.title}</Typography>
                </Box>
                <Typography variant="h4">{item.count}</Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={() => navigate(item.path)}>
                  Voir {item.title}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Admin; 